export enum UsersFilterType 
{
	PROPERTY = "property",
	PRODUCT = "product",
	SUB_PRODUCT = "sub_product",
	SMS_NUMBER = "sms_number",
};

export enum UserPropertyIds
{
	PROPERTY = "property", // the top level topic
	ADMINS = "admins",
	USERS = "users",
	VERIFIED = "verified",
	UNVERIFIED = "unverified",
	PBX = "pbx",
	CONNECT = "connect",
	IOT = "iot",
	INACTIVE = "inactive"
}
export enum UserProductId
{
  PRODUCT = "product"
}
export enum UserSmsNumberId {
	SMS_NUMBER_ASSIGNED = "sms_number_assigned",
	SMS_NUMBER_SEARCH = "sms_number_search",
}
export enum UserPreFilterReasons
{
	XLAUNCH = "xlaunch"
}